export default __webpack_public_path__ + "static/media/RakshabandanNew2.b91a3a86.png";